import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
/**
 * Terminus NavPlatformSwitcherMenuListComponent Component v1.0.0
 */
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SubNavItem } from '../../models/nav.model';

@Component({
  selector: 'tux-nav-platform-switcher-menu-list',
  templateUrl: './nav-platform-switcher-menu-list.component.html',
  styleUrls: ['./nav-platform-switcher-menu-list.component.scss'],
  imports: [CommonModule, FontAwesomeModule, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavPlatformSwitcherMenuListComponent {
  @Input() items!: SubNavItem[] | undefined;
}
